import { useNavigation } from '@react-navigation/native';
import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';
import { Pressable, StyleSheet, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import colors, { appTheme } from '@/config/colors';
import { useDialog } from '@/hooks/useDialog';
import { Text } from '@/components/Text';
import {
  confirmPasswordValidate,
  passwordValidate,
} from '@/utils/passwordUtils';
import { PREPARED_DIALOGS } from '@/components/ui/shared/Dialog/constants';

import { SharedFormField } from '@/components/SharedComponents/FormField/SharedFormField';
import { usePasswordFormController } from '@/components/ChangePassword/usePasswordFormController';

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    backgroundColor: 'white',
  },
  formWrapper: {
    justifyContent: 'center',
  },

  loginButtonStyle: {
    backgroundColor: appTheme.primary,
  },
  loginInputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  loginContainer: {
    flex: 1,
    backgroundColor: colors.white,
  },
  redText: {
    color: colors.red,
  },
});

function PasswordChangeForm(props) {
  const { showDialog, removeDialog } = useDialog();
  const { passwordResetToken } = props;

  const navigation = useNavigation();

  const localDialogOptions = {
    success: {
      title: 'Passwort geändert',
      content: 'Passwort wurde erfolgreich geändert.',
      cancelable: false,
      confirmAction: {
        label: 'weiter',
        onPress: () => {
          removeDialog();
          navigation.navigate('Home');
        },
      },
    },
    error: {
      title: 'Login fehlgeschlagen!',
      content:
        'Ihr Passwort oder Ihre E-Mail-Adresse sind falsch. Oder Sie haben sich noch nicht bei neolexon registriert!',
      cancelable: false,
      danger: true,
    },
  };

  const { control, newPasswordFilled, handlePasswordSubmit } =
    usePasswordFormController({
      passwordResetToken,
      onSuccess: () => showDialog(localDialogOptions.success),
      onError: () => showDialog(localDialogOptions.error),
      onNetworkError: () => showDialog(PREPARED_DIALOGS.noInternetDialog()),
      onResetSuccess: () =>
        navigation.navigate('PublicConfirmationPage', {
          title: 'Ihr Passwort wurde erfolgreich zurückgesetzt',
          text: 'Sie können dieses Fenster schließen und sich erneut in der Neolexon–App anmelden.',
        }),
      onResetError: () =>
        showDialog({
          title: 'Fehler beim Zurücksetzen',
          content:
            'Leider konnte Ihr Passwort nicht zurückgesetzt werden. Versuchen Sie es bitte erneut.',
          danger: true,
          cancelable: false,
        }),
    });
  return (
    <View style={styles.loginContainer}>
      <KeyboardAwareScrollView
        contentContainerStyle={[styles.wrapper]}
        enableOnAndroid={true}
        extraHeight={useResponsiveHeight(30)}
      >
        <View className="w-1/2 max-w-[600px]">
          {passwordResetToken ? null : (
            <SharedFormField
              control={control}
              name="currentPassword"
              label="Aktuelles Passwort"
              rules={{ required: 'Pflichtfeld' }}
              secureTextEntry
              usePasswordInput
            />
          )}

          <View className="mt-4">
            <SharedFormField
              control={control}
              name="newPassword"
              label="Neues Passwort"
              rules={{
                required: 'Pflichtfeld',
                minLength: {
                  value: 8,
                  message:
                    'Passwort muss mindestens 8 Zeichen lang sein und darf Buchstaben, Zahlen, Sonderzeichen und Leerzeichen enthalten.',
                },
                validate: (value) => passwordValidate(value),
              }}
              secureTextEntry
              usePasswordInput
            />
          </View>
          <View className="mt-4">
            <SharedFormField
              control={control}
              name="verifyPassword"
              label="Neues Passwort wiederholen"
              rules={{
                required: 'Pflichtfeld',
                validate: (value) =>
                  confirmPasswordValidate(value, newPasswordFilled),
              }}
              secureTextEntry
              usePasswordInput
            />
          </View>
          <Pressable
            className="mt-4 p-4 rounded-md"
            style={{ backgroundColor: appTheme.primary }}
            onPress={handlePasswordSubmit}
          >
            <Text className="text-xl text-center text-white">
              Passwort ändern
            </Text>
          </Pressable>
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
}

export default PasswordChangeForm;
